import { ApplicationsAPI } from "api/api/applicationsApi/applicationsApi";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  GetMyApplicationsParams,
  GetMyApplicationsResponse,
} from "api/api/applicationsApi/types";
export const getMyApplications = createAsyncThunk<
  GetMyApplicationsResponse,
  GetMyApplicationsParams
>("applications/getMyApplications", async (params, { rejectWithValue }) => {
  try {
    const data = await ApplicationsAPI.getMyApplications(params);
    return data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error(
        "Error while getting my applications",
        error.response?.data
      );
      return rejectWithValue(error.response?.data || "Unknown error");
    } else {
      console.error("Error while getting my applications", error);
      return rejectWithValue(
        "Что-то пошло не так... Попробуйте обновить страницу"
      );
    }
  }
});
